var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotshow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.7,
    height: 19.625,
    viewBox: "0 0 23.7 19.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1014",
    "data-name": "Rectangle 1014",
    width: 23.7,
    height: 19.625,
    transform: "translate(0 -0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Not_show",
    "data-name": "Not show",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M23.611,9.282c-.174-.346-4.321-8.47-11.76-8.47h-.013a9.978,9.978,0,0,0-2.281.263.849.849,0,1,0,.387,1.654,7.393,7.393,0,0,1,1.906-.218c5.539,0,9.149,5.617,10.031,7.15a17.873,17.873,0,0,1-1.841,2.644.85.85,0,1,0,1.3,1.094,19.34,19.34,0,0,0,2.26-3.337.849.849,0,0,0,.011-.78",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M3.734.249a.85.85,0,0,0-1.2,1.2L4.712,3.628A19.142,19.142,0,0,0,.1,9.259a.85.85,0,0,0-.012.782c.174.346,4.322,8.47,11.775,8.47a10.831,10.831,0,0,0,5.9-1.851l2.721,2.716a.85.85,0,1,0,1.2-1.2Zm6.13,8.524,2.88,2.877a2.135,2.135,0,0,1-.893.235,2.086,2.086,0,0,1-1.542-.576,2.118,2.118,0,0,1-.445-2.536m1.986,8.039C6.312,16.812,2.7,11.2,1.821,9.664A17.432,17.432,0,0,1,5.915,4.83L8.63,7.541a3.838,3.838,0,0,0,3.142,6.045c.046,0,.093,0,.139,0a3.814,3.814,0,0,0,2.072-.7l2.549,2.545a9.129,9.129,0,0,1-4.682,1.38",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotshow);
export default __webpack_public_path__ + "static/media/Notshow.a7848231d6efa7f62b6c09129529d9fa.svg";
export { ForwardRef as ReactComponent };